<template>
	<v-card class="mt-4">
		<agency-documents-list
			:contest-id="contestData.id"
			:documents="contestDocuments"
			color="blue"
			document-type="CONTEST_DOCUMENT"
			header="Dokumenty Naboru"
			:readonly="true"
		/>
		<agency-documents-list
			class="mt-4"
			:contest-id="contestData.id"
			:documents="infoDocuments"
			color="blue"
			document-type="INFO_DOCUMENT"
			header="Dokumenty Informacyjne"
			:readonly="true"
		/>
	</v-card>
</template>

<script>
	import AgencyDocumentsList from "./components/AgencyDocumentsList";
	import {AgencyContestDocument} from "@/api/generated/AgencyContestDocument";

	export default {
		name: "AgencyDocumentsReadOnlyView",

		components: {AgencyDocumentsList},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				contestDocuments: [],
				infoDocuments: [],
			};
		},

		created() {
			loadDocuments(this);
		},
	};

	function loadDocuments(ctx) {
		AgencyContestDocument.getReadOnly(ctx, ctx.contestData.id,
			successResponse => {
				successResponse.forEach(function (document) {
					addDocumentToView(ctx, document);
				});
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować dokumentów", errorResponse);
			});
	}

	function addDocumentToView(ctx, document) {
		if (document.agencyContestDocumentType === "CONTEST_DOCUMENT") {
			ctx.contestDocuments.push(document);
		} else {
			ctx.infoDocuments.push(document);
		}
	}
</script>

<style scoped>

</style>
